export default __webpack_public_path__ + "static/media/adobe-tech-5.226d1a7f.webp";